<template>
  <div class="c-project-card">
    <div class="c-project-card__figure">
      <img :src="entry.image" :alt="entry.title">
    </div>
    <!-- <img class="c-project-card__figure" :src="entry.image" :alt="entry.title"> -->
    <div class="c-project-card__body">
      <h4 class="c-project-card__heading u-h5">{{ entry.title }}</h4>
      <div class="u-ff-alt u-st1 u-italic">
        <p>{{ entry.summary }}</p>
      </div>
      <div class="c-project-card__read-more">
        <router-link class="c-read-more c-read-more--reversed c-read-more--spaced u-st2" :to="{ name: 'project', params: { slug: entry.slug }}">
          Find out more <img class="c-read-more__img" src="@/assets/arrow-right-blue.svg" width="32" alt="Right arrow">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectCard',
  props: ['entry']
}
</script>



// WEBPACK FOOTER //
// src/components/ProjectCard.vue